"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isListResult = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isListResult = (data) => {
    var _a;
    return Array.isArray(data === null || data === void 0 ? void 0 : data.data) && typeof ((_a = data === null || data === void 0 ? void 0 : data.pagination) === null || _a === void 0 ? void 0 : _a.total) === 'number';
};
exports.isListResult = isListResult;
//# sourceMappingURL=isListResult.js.map